stimulusApp.register(
  "search",
  class extends Stimulus.Controller {
    static targets = ["openui", "closeui", "root", "input", "openButton"]

    open() {
      this.#setOpenState(true)
      this.#focusInput()
    }

    close() {
      this.#setOpenState(false)
      if (this.hasOpenButtonTarget)
        this.openButtonTarget.focus({ preventScroll: true })
    }

    #setOpenState(isOpen) {
      if (this.hasRootTarget) {
        this.rootTarget.classList.toggle("header-search_opened", isOpen)
      }

      // Elements visible when closed
      this.closeuiTargets.forEach((el) => el.classList.toggle("hidden", isOpen))

      // Elements visible when open
      this.openuiTargets.forEach((el) => el.classList.toggle("hidden", !isOpen))
    }

    #focusInput() {
      if (!this.hasInputTarget) return

      const el = this.inputTarget

      // Focus synchronously on the same user-gesture handler (required for iOS to show keyboard)
      el.focus({ preventScroll: true })

      // Fallback: iOS may ignore the first focus — retry on next macrotask
      setTimeout(() => {
        if (document.activeElement !== el) {
          el.focus({ preventScroll: true })
          el.setSelectionRange?.(el.value.length, el.value.length)
        }
      })
    }
  },
)
